import { FAQService } from './../../../../core/services/FAQ/FAQ.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { serverError } from './../../../../core/models/messages';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css'],
})
export class FaqComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  /* pagination */
  listtuto: any;
  totalItems: number = 10;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  startIndex: number = 0;
  endIndex: number = 10;
  private unsubscribeAll: Subject<void> = new Subject();
  listFaq: any;
  loadSpinner: boolean = false;
  loadSpinnerTable: boolean = false;
  pagination : boolean =false;
  offset: number = 0;
  searchFormGroup: FormGroup = this.createSearchForm();
  ispagination: boolean = true;
  constructor(
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private faqService: FAQService
  ) {}
  ngOnInit() {
    this.getListFaq();
  }
  getListFaq() {
    this.spinner.show();
    this.loadSpinnerTable = true;
    this.faqService.getAllFaq(this.itemsPerPage, this.currentPage).subscribe({
      next: (res) => {
        if (res.status === 200) {
          console.log('response', res);
          const responseData: any = res.data.data;
          this.listFaq = res.data.data
          // .slice(0, this.endIndex);
          // this.totalItems = responseData.length;
          this.totalItems = res.data.total;
          this.offset = (this.currentPage - 1) * this.itemsPerPage;
          
        }
        this.spinner.hide();
        this.loadSpinnerTable = false;
      },
      error: (err: Error) => {
        this.toastrService.error(serverError);
        this.spinner.hide();
        this.loadSpinnerTable = false;
      },
    });
  }
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
        if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){          this.pagination = true
          this.getListFaq();
        }
    }
  }
  reset() {
    this.currentPage = 1;
    this.searchFormGroup.reset();
    this.searchFormGroup = this.createSearchForm();
    this.getListFaq();
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      search: [null, data?.search],
      type: ['', data?.type],
    });
  }

  applyFilter() {
    let data = {
      type: 3,
      search: this.searchFormGroup.value.search,
      page: this.currentPage,
      per_page: this.itemsPerPage,
    };
    this.spinner.show();
    this.faqService
      .searchfaq(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('res', res);
          // this.listFaq =res.data.data
          // console.log("listefaq",this.listFaq)
          // this.totalItems = res.data.total;
          // // this.totalItems = res.data.length
          // console.log("total",this.totalItems)
          // this.spinner.hide();
          if (
            !res.data.data.length &&
            this.currentPage > 1 &&
            !this.ispagination
          ) {
            console.log('ifffffffff');
            this.currentPage = 1;
            this.offset = (this.currentPage - 1) * this.itemsPerPage;
            this.applyFilter();
          } else {
            this.listFaq = res.data.data.slice(0, this.endIndex);
            this.totalItems = res.data.total;
            this.ispagination = true;
            this.spinner.hide();
          }
        },
        error: () => {
          this.toastrService.error('Erreur serveur');
          this.spinner.hide();
        },
      });
  }
  noResults() {
    this.spinner.hide();
    this.listFaq = [];
  }
}
